import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination } from "swiper";
import { Link } from "react-router-dom";
import useFetch from "../../utils/useFetch";

function Slider() {
  const Api = `system/home-page-carousels/?ordering=priority`;
  const { data, loading, error } = useFetch(`${Api}`);

  if (loading) return (
    <Swiper
      spaceBetween={30}
      className="mySwiper"
      loop={true}
      centeredSlides={true}
      modules={[Autoplay, Pagination]}
      autoplay={{ delay: 5000 }}
      pagination={{ clickable: true }}
    >
      <SwiperSlide>
        <div className="flex flex-row bg-white h-[60vh] w-full px-5 md:px-20">
          {/* Left Content Skeleton */}
          <div className="flex w-1/2 flex-col justify-center items-start p-4">
            <div className="h-12 bg-gray-200 animate-pulse rounded-lg mb-4 w-3/4"></div>
            <div className="h-4 bg-gray-200 animate-pulse rounded-lg mb-2 w-full"></div>
            <div className="h-4 bg-gray-200 animate-pulse rounded-lg mb-4 w-2/3"></div>
            <div className="h-10 bg-gray-200 animate-pulse rounded-md mt-6 w-32"></div>
          </div>
          
          {/* Right Image Skeleton */}
          <div className="flex w-1/2 justify-center items-center">
            <div className="w-full h-[80%] bg-gray-200 animate-pulse rounded-lg"></div>
          </div>
        </div>
      </SwiperSlide>
    </Swiper>
  );
  if (error) return <p>Error loading data</p>;

  return (
    <Swiper
      spaceBetween={30}
      loop={true}
      centeredSlides={true}
      autoplay={{
        delay: 5000,
        disableOnInteraction: false,
      }}
      pagination={{
        clickable: true,
      }}
      modules={[Autoplay, Pagination]}
      className="mySwiper"
    >
      {data?.results?.map((item, index) => (
        <SwiperSlide key={index}>

            <div className="flex flex-row bg-white h-[60vh] w-full px-0 sm:px-10 2xl:px-52 ">

              <div className="flex  w-1/2 flex-col justify-center items-start p-4">
                <h1 className="mb-2 text-2xl  lg:text-5xl font-bold text-black rounded-lg">
                  {item.title} lorem ipsum
                </h1>
                <span className="text-base leading-6 text-black rounded-lg ">
                  {item.subtitle} lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </span>
                <Link
                  className="inline-block lg:inline-block text-sm leading-6 font-normal mt-6 px-6 py-2 bg-brand-600 text-center rounded-md text-white hover:bg-brand-700"
                  to={item.button_url}
                >
                  {item.button_text}
                </Link>
              </div>

              <div className="flex w-1/2 justify-center items-center">
                <img
                  alt={item.title}
                  src={item.banner}
                  decoding="async"
                  className="max-h-full max-w-full object-cover"
                />
              </div>
            </div>

        </SwiperSlide>
      ))}
    </Swiper>
  );
}

export default Slider;